import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const KEY = "theme";
const ThemeContext = createContext({ theme: "dark", setTheme: () => {}, toggle: () => {} });

const apply = (theme) => {
  const root = document.documentElement;
  root.classList.toggle("dark", theme === "dark");
  root.style.colorScheme = theme;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem(KEY) : null;
    return saved === "light" || saved === "dark" ? saved : "dark"; // dark by default
  });
  useEffect(() => apply(theme), [theme]);
  const setTheme = useCallback((t) => {
    localStorage.setItem(KEY, t);
    setThemeState(t);
  }, []);
  const toggle = useCallback(() => setTheme(theme === "dark" ? "light" : "dark"), [theme, setTheme]);
  const value = useMemo(() => ({ theme, setTheme, toggle }), [theme, setTheme, toggle]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
